<template>
  <section class="links">
    <div class="links__inner">

      <!-- Header -->
      <div class="links__header">
        <h2 class="links__title">{{ $t('home.linksTitle') }}</h2>
      </div>

      <!-- Cards (auto-swiping carousel on mobile) -->
      <div
        class="links__grid"
        ref="grid"
        @mouseenter="stopAuto"
        @mouseleave="startAuto"
        @touchstart="stopAuto"
        @touchend="startAuto"
      >
        <div class="links__card" v-for="(item, i) in loopCards" :key="i">

          <!-- upper part: icon + name (341×121) — clickable -->
          <a :href="item.url" class="links__top" target="_blank" rel="noopener">
            <img :src="item.icon" alt="" class="links__icon" />
            <p class="links__name">{{ $t(item.nameKey) }}</p>
          </a>

        </div>
      </div>

    </div>
  </section>
</template>

<script>
import logo1 from '@/assets/img/logos/logo1.png'
import logo2 from '@/assets/img/logos/logo2.png'
import logo3 from '@/assets/img/logos/logo3.png'
import logo4 from '@/assets/img/logos/logo4.png'

export default {
  name: 'FoydaliHavolalar',
  data() {
    return {
      timer: null,
      isMobile: typeof window !== 'undefined' && window.innerWidth <= 768,
      cards: [
        { icon: logo1, nameKey: 'home.linkIma',   url: 'https://gov.uz/oz/ima' },
        { icon: logo2, nameKey: 'home.linkGov',   url: 'https://gov.uz/oz' },
        { icon: logo3, nameKey: 'home.linkUzedu', url: 'https://gov.uz/oz/uzedu' },
        { icon: logo4, nameKey: 'home.linkOliy',  url: 'https://gov.uz/oz/edu/uz' }
      ]
    }
  },
  computed: {
    // On mobile we render two copies so the carousel can loop seamlessly to the
    // right (no jump back to the start). Desktop keeps the original 4.
    loopCards() {
      return this.isMobile ? [...this.cards, ...this.cards] : this.cards
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.startAuto()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
    this.stopAuto()
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768
    },
    startAuto() {
      this.stopAuto()
      this.timer = setInterval(this.next, 2000)   // swipe every 2s
    },
    stopAuto() {
      if (this.timer) { clearInterval(this.timer); this.timer = null }
    },
    next() {
      const el = this.$refs.grid
      if (!el) return
      if (el.scrollWidth - el.clientWidth <= 1) return   // not scrollable (desktop)
      const kids = el.children
      // step = one card (card width + gap); wrap = width of one full set
      const step = kids.length > 1 ? kids[1].offsetLeft - kids[0].offsetLeft : el.clientWidth
      const wrap = kids[this.cards.length] ? kids[this.cards.length].offsetLeft - kids[0].offsetLeft : el.scrollWidth
      let left = el.scrollLeft
      // once a full set has passed, snap back by one set (identical content =
      // invisible) so the swipe keeps moving rightward forever
      if (left >= wrap - 1) {
        left -= wrap
        el.scrollTo({ left, behavior: 'auto' })
      }
      el.scrollTo({ left: left + step, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/components/06foydali_havolalar/foydali_havolalar.scss';
</style>
